import {Component, Vue} from 'vue-property-decorator';
import {
  userIcon,
  usersIcon,
  businessIcon,
  lockIcon,
} from '@deanone/dean-components';

@Component({})
export default class SideMenuProfileMixin extends Vue {
  public buildSideMenuProfile() {
    const sideMenu = {
      content: {
        title: {
          text: 'instellingen',
          mobile: {
            close: {
              text: 'Close',
            },
          },
        },
        type: 'themed',
        sections: {
          general: {
            items: {
              account: {
                title: 'Mijn account',
                icon: userIcon,
                name: 'profile.myAccount',
              },
              users: {
                title: 'Gebruikers',
                icon: usersIcon,
                name: 'profile.users',
              },
              contacts: {
                title: 'Contacten',
                icon: usersIcon,
                name: 'profile.contacts',
              },
              organization: {
                title: 'Mijn organisatie',
                icon: businessIcon,
                name: 'profile.myOrganization',
              },
              changePassword: {
                title: 'Wachtwoord wijzigen',
                icon: lockIcon,
                name: 'profile.changePassword',
                keycloakAction: 'UPDATE_PASSWORD',
              },
            },
          },
        },
      },
    };
    this.$store.dispatch('updateSideMenu', sideMenu);
  }
}
